import React from 'react'
import { HeadCard } from '../../structure/card/HeadCard'
import { DatatableCompraMembresias } from './DatatableCompraMembresias'

export const CompraMembresiasPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Compra Membresias" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>

                    <DatatableCompraMembresias />

                </div>
            </section>
        </div>
    )
}
